<template>
  <footer class="footer">
    © 2023
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
}
</script>

<style lang="scss">
.footer {
  // border: 1px solid blue;
  height: 50px;
  flex-shrink: 0;

  background: #000;
  color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>